<script>
    import {links, navigate} from "svelte-routing";
    import UserManagementComponent from "../UserManagement/UserManagementComponent.svelte";
    import GeneralSettingsComponent from "./GeneralSettingsComponent.svelte";
    import UserProfileComponent from "../UserManagement/ManageUser/UserProfileComponent.svelte";

    export let model_root;
    export let active;
</script>

<h4 class="text-muted">FujanaCMS</h4>
<h2 class="mb-4">Einstellungen</h2>

<div use:links>

    <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
            <a class:active="{active === 'general_settings'}" class="nav-link" href="/settings/"><i class="fas fa-cog"></i> Einstellungen</a>
        </li>
        <li class="nav-item">
            <a class:active="{active === 'user_management'}" class="nav-link" href="/settings/users/"><i class="fas fa-user-friends"></i> Nutzer verwalten</a>
        </li>
        <li class="nav-item">
            <a class:active="{active === 'profile'}" class="nav-link" href="/settings/profile/"><i class="fas fa-user-circle"></i> Mein Account</a>
        </li>
    </ul>

    {#if active === 'general_settings'}
        <GeneralSettingsComponent />
    {/if}

    {#if active === 'user_management'}
        <UserManagementComponent {model_root} />
    {/if}

    {#if active === 'profile'}
        <UserProfileComponent {model_root} />
    {/if}

</div>
